import type { ThemeVariantMap } from "@/theme/types";

import { vapianoDarkTheme } from "./vapiano.dark";
import { vapianoLightTheme } from "./vapiano.light";

export const vapianoTheme: ThemeVariantMap = {
  LIGHT: vapianoLightTheme,
  DARK: vapianoDarkTheme,
} as const;
